module.exports = __webpack_public_path__ + "static/media/albums-questions.dfd78fa3.csv";